/*
 * Hook for handling window resize events.
 * @param callback - The callback function to call when the window is resized
 * @param active - (Optional) whether the hook is active
 * @returns void
 */

import { useEffect } from "react";

interface UseWindowResizeProps {
  callback: () => void;

  /** @default true */
  active?: boolean;
}

export function useWindowResize(props: UseWindowResizeProps) {
  const { callback, active = true } = props;

  useEffect(() => {
    if (typeof window === "undefined" || !active) return;

    window.addEventListener("resize", callback);

    return () => {
      window.removeEventListener("resize", callback);
    };
  }, [active]);
}
